import { createAsyncThunk } from '@reduxjs/toolkit';

import { arbitroNomeacoesService } from './services';

export const fetchNomeacoes = createAsyncThunk(
  'arbitroNomeacoes/fetch',
  async (_arg, { rejectWithValue }) => {
    try {
      return await arbitroNomeacoesService.listar();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const aceitarNomeacao = createAsyncThunk(
  'arbitroNomeacoes/aceitar',
  async (id: string, { rejectWithValue }) => {
    try {
      return await arbitroNomeacoesService.aceitar(id);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const recusarNomeacao = createAsyncThunk(
  'arbitroNomeacoes/recusar',
  async ({ id, motivo }: { id: string; motivo: string }, { rejectWithValue }) => {
    try {
      return await arbitroNomeacoesService.recusar(id, motivo);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
